import { render, staticRenderFns } from "./dashboard-new.vue?vue&type=template&id=04a8bbfa&scoped=true"
import script from "./dashboard-new.vue?vue&type=script&lang=js"
export * from "./dashboard-new.vue?vue&type=script&lang=js"
import style0 from "./dashboard-new.vue?vue&type=style&index=0&id=04a8bbfa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8bbfa",
  null
  
)

export default component.exports